import { t } from "i18next";
import jsPDF from "jspdf";
import autoTable, { jsPDFDocument, Styles } from "jspdf-autotable";

import { ReturnDetails } from "../../returns.types";

interface renderPaymentProps {
  pdf: jsPDF;
  returnDetails?: ReturnDetails;
  normalFontStyles: Partial<Styles>;
}

export const renderPayment = ({
  pdf,
  returnDetails,
  normalFontStyles
}: renderPaymentProps) => {
  const refundTotal = returnDetails?.refundTotal ?? 0;

  autoTable(pdf, {
    theme: "plain",
    startY: (pdf as jsPDFDocument).lastAutoTable.finalY,
    styles: { cellPadding: 5 },
    head: [
      [
        {
          content: `${t("Refund Total")}: ${refundTotal?.toLocaleString("en-US")} FCFA`,
          styles: {
            valign: "middle",
            halign: "right",
            ...normalFontStyles,
            cellPadding: { top: 5, bottom: 1, horizontal: 5 }
          }
        }
      ]
    ],
    body: [
      [
        {
          content: `${t("Delivery Fee")}: 0,0 FCFA`,
          styles: {
            valign: "middle",
            halign: "right",
            ...normalFontStyles,
            cellPadding: { top: 1, bottom: 5, horizontal: 5 }
          }
        }
      ]
    ],
    tableLineWidth: 1,
    tableLineColor: "#000000"
  });
};
